import { H5, H6 } from "@sellar-io/components";

export type OrderPaymentMethodProps = {
  method: string;
};

export const OrderPaymentMethod = (
  props: OrderPaymentMethodProps,
): React.ReactElement => {
  return (
    <div className="flex flex-col gap-2">
      <H5>Method</H5>
      <div>
        <H6>{props.method}</H6>
      </div>
    </div>
  );
};
